<script setup lang="ts">
interface Props {
  energy: number
  capacity: number
}

const props = defineProps<Props>()

// 残量割合（0〜1）
const ratio = computed(() => Math.min(props.energy / props.capacity, 1))

// 色（残量に応じて濃淡を変える）
const liquidColor = computed(() => {
  const c1 = `rgba(90, 120, 255, ${0.7 + ratio.value * 0.3})` // 青
  const c2 = `rgba(160, 70, 255, ${0.5 + ratio.value * 0.5})` // 紫
  return `linear-gradient(to top, ${c1}, ${c2})`
})
</script>

<template>
  <div class="pot-wrapper">
    <!-- 数値表示 -->
    <div class="pot-value-wrapper">
      <div class="pot-value-top">
        {{ energy }}
      </div>
      <div class="pot-value-bottom">
        /{{ capacity }}
      </div>
    </div>
    <div class="pot">
      <!-- 液体レイヤー（高さ可変） -->
      <div class="pot-mask">
        <div
          class="liquid"
          :style="{
            transform: `scaleY(${ratio})`,
            background: liquidColor,
          }"
        />
      </div>

      <!-- 壺の画像（透明穴あき） -->
      <img
        src="@/assets/images/pot_base.png"
        class="pot-img"
        alt="pot"
      >
    </div>
  </div>
</template>

<style scoped>
.pot-wrapper {
    position: relative;

    display: inline-flex;
    flex-direction: column;
    align-items: center;
    width: max(26.7px, calc(3.75 * var(--u)));
    margin: 0;
}

/* 数字表示 */
.pot-value-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -20%);

    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
    z-index: 10;
}

.pot-value-top {
    font-size: max(8.89px, calc(1.25 * var(--u)));
    font-weight: 700;
    color: #ffffff;
    text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
}

.pot-value-bottom {
    font-size: max(4.44px, calc(0.625 * var(--u)));
    font-weight: 600;
    color: #ccddff;
    text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
    margin-top: -4px;
    /* 行間ぎゅっと */
}

/* 壺と液体を重ねるためのコンテナ */
.pot {
    position: relative;
    width: max(26.7px, calc(3.75 * var(--u)));
    height: max(44.4px, calc(6.25 * var(--u)));
    overflow: hidden;
}

.pot-mask {
    position: absolute;
    inset: 0;
    /* マスク適用（中身だけ表示） */
    -webkit-mask-image: url('@/assets/images/pot_mask.png');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;

    mask-image: url('@/assets/images/pot_mask.png');
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;

    display: flex;
    align-items: flex-end;
    /* 下から液体が満ちる感じに */
    justify-content: center;
    overflow: hidden;
}

/* 液体レイヤー */
.liquid {
    width: 100%;
    height: 55%;
    margin-bottom: 10%;
    transform-origin: bottom center;
    transition: transform 0.3s ease, background 0.3s ease;
}

/* メモリ線 */
.tick {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.25);
}

/* 壺PNG */
.pot-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: auto;
    pointer-events: none;
}
</style>
